import { type ObjectiveStatus } from '@/platform/learning/contract'

/** Child-facing result wording (first-learning-journey §4, §6.2). */

/** first-learning-journey §6.2. Mock wording takes priority. */
export const MOCK_RESULT_NOTE =
  'Đây là kết quả mô phỏng, không được lưu và không phải kết quả học tập thật.'
export const SAMPLE_CONTENT_RESULT_NOTE =
  'Bài làm của con đã được ghi lại. Nội dung bài là nội dung mẫu, chưa được kiểm duyệt.'

/** first-learning-journey §4: cautious and limited to this attempt. */
export const OBJECTIVE_STATUS_TEXT: Readonly<Record<ObjectiveStatus, string>> = {
  insufficient_evidence: 'Chưa đủ dữ liệu trong bài này.',
  needs_practice: 'Bài này cho thấy con nên luyện thêm phần này.',
  observed_correct: 'Con trả lời đúng các câu hỏi được quan sát trong bài này.',
}

export const PRACTICE_HEADING =
  'Gợi ý luyện thêm — chỉ dựa trên câu trả lời trong bài này.'
